// import React,{useState, useSyncExternalStore} from 'react'

export default function About(props) {
  // const [btnStyle,setBtnStyle]= useState({
  //   color: 'black',
  //   backgroundColor: 'white'
  // })

//  const [myStyle, setMyStyle] = useState({
//     color:"white",
//     backgroundColor: "black"
//   })
let myStyle={
  color: props.mode ==='dark'?"white":"black",
  backgroundColor: props.mode ==='dark'?"black":"white"
}
  return (
    <div  className="accordion" id="accordionExample">
      <div  className="accordion-item" style={myStyle}>
    <h2  className="accordion-header" id="headingThree"style={myStyle}>
      <button  className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" style={myStyle}>
       Use of this site
      </button>
    </h2>
    <div id="collapseThree"  className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
      <div  className="accordion-body" style={myStyle}>
        This Site can change your text to  uppercase and to lowercase with the help of <code>Convert to uppercase </code> and <code>Convert to Lowercase </code> buttons respectivly and you can copy your changed text with the help of Copy text button. Also remove the extra spaces from your text which will save your lots of time.This site also help you to know how much alphabet, words, sentences in your paragraph or your text.
      </div>
    </div>
  </div>
  <div  className="accordion-item">
    <h2  className="accordion-header" id="headingOne">
      <button  className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style={myStyle}>
        What is Later case?
      </button>
    </h2>
    <div id="collapseOne"  className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
      <div  className="accordion-body" style={myStyle}>
        <strong>Letter case</strong> is the distinction between the letters that are in larger uppercase or capitals (or more formally majuscule) and smaller lowercase (or more formally minuscule) in the written representation of certain languages. The writing systems that distinguish between the upper and lowercase have two parallel sets of letters, with each letter in one set usually having an equivalent in the other set. The two case variants are alternative representations of the same letter: they have the same name and pronunciation and are treated identically when sorting in alphabetical order.
      </div>
    </div>
  </div>
  <div  className="accordion-item">
    <h2  className="accordion-header" id="headingTwo">
      <button  className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" style={myStyle}>
      Capitalisation
      </button>
    </h2>
    <div id="collapseTwo"  className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
      <div  className="accordion-body" style={myStyle}>
        <strong>Capitalisation </strong>is the writing of a word with its first letter in uppercase and the remaining letters in lowercase. Capitalisation rules vary by language and are often quite complex, but in most modern languages that have capitalisation, the first word of every sentence is capitalised, as are all proper nouns.
      </div>
    </div>
  </div>
  
</div>
  )
}
